import React from 'react';
import { Container, Nav, Tab } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { Music, TrendingUp, BarChart, BookOpen, Languages } from 'lucide-react';
import Navigation from '../components/Navigation/Navigation';
import SongEdit from './SongEditPage';
import SongCollectionsPage from './SongCollectionsPage';
import MostUsedSongsPage from './MostUsedSongsPage';
import MeterManagementPage from './MeterManagementPage';
import TuneManagementPage from './TuneManagementPage';
import LectionaryPage from './LectionaryPage';
import SpanishSongsPage from './SpanishSongsPage';

const BrowsePage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'songs';
  const songIdParam = searchParams.get('songId');

  const handleTabSelect = (key: string | null) => {
    if (key) {
      // Preserve songId when switching to songs tab, clear otherwise
      if (key === 'songs' && songIdParam) {
        setSearchParams({ tab: key, songId: songIdParam });
      } else {
        setSearchParams({ tab: key });
      }
    }
  };

  return (
    <>
      <Navigation />
      <Container fluid className="page-below-nav px-4">
        <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
          <Nav variant="tabs" className="mb-3 browse-tabs">
            <Nav.Item>
              <Nav.Link eventKey="songs" className="d-flex align-items-center gap-2">
                <Music size={18} />
                Songs
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="collections" className="d-flex align-items-center gap-2">
                <BookOpen size={18} />
                Chants &amp; Circle Songs
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="spanish" className="d-flex align-items-center gap-2">
                <Languages size={18} />
                Spanish Songs
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="most-used" className="d-flex align-items-center gap-2">
                <TrendingUp size={18} />
                Most Used
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="meters" className="d-flex align-items-center gap-2">
                <BarChart size={18} />
                Meters
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="tunes" className="d-flex align-items-center gap-2">
                <Music size={18} />
                Tunes
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="lectionary" className="d-flex align-items-center gap-2">
                <BookOpen size={18} />
                Lectionary
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="songs">
              {activeTab === 'songs' && <SongEdit key={`${songIdParam || 'new'}-${searchParams.get('new')}-${searchParams.get('collection')}`} hideNavigation initialSongId={songIdParam ? parseInt(songIdParam) : undefined} startNew={searchParams.get('new') === '1'} initialCollection={searchParams.get('collection') || undefined} />}
            </Tab.Pane>
            <Tab.Pane eventKey="collections">
              {activeTab === 'collections' && <SongCollectionsPage />}
            </Tab.Pane>
            <Tab.Pane eventKey="spanish">
              {activeTab === 'spanish' && <SpanishSongsPage hideNavigation />}
            </Tab.Pane>
            <Tab.Pane eventKey="most-used">
              {activeTab === 'most-used' && <MostUsedSongsPage hideNavigation />}
            </Tab.Pane>
            <Tab.Pane eventKey="meters">
              {activeTab === 'meters' && <MeterManagementPage hideNavigation />}
            </Tab.Pane>
            <Tab.Pane eventKey="tunes">
              {activeTab === 'tunes' && <TuneManagementPage hideNavigation />}
            </Tab.Pane>
            <Tab.Pane eventKey="lectionary">
              {activeTab === 'lectionary' && <LectionaryPage hideNavigation />}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>
    </>
  );
};

export default BrowsePage;
